import { motion, useReducedMotion } from 'framer-motion';

import {
  formatShortlistPageMetaSuffix,
  formatShortlistPageTitle,
} from '@/modules/public-shortlist/shortlistCopy';
import {
  getShortlistRevealInitial,
  getShortlistRevealTransition,
  SHORTLIST_LOAD_DELAYS,
  shortlistRevealVisible,
} from '@/modules/public-shortlist/shortlistMotion';
import { Heading } from '@/modules/ui/components/heading/Heading';

interface ShortlistPageHeaderProps {
  companyName: string;
  count: number;
  jobTitle: string;
  location?: string;
}

export function ShortlistPageHeader({
  companyName,
  count,
  jobTitle,
  location,
}: ShortlistPageHeaderProps) {
  const prefersReducedMotion = useReducedMotion();

  return (
    <motion.header
      initial={getShortlistRevealInitial(prefersReducedMotion)}
      animate={shortlistRevealVisible}
      transition={getShortlistRevealTransition(
        prefersReducedMotion,
        SHORTLIST_LOAD_DELAYS.hero,
      )}
      className="text-left"
    >
      <p className="text-neutral-650 text-xs font-semibold tracking-[0.14em] uppercase">
        Shortlist · Live
      </p>

      <Heading
        id="shortlist-candidates-heading"
        variant="h1"
        className="mt-3 text-left leading-[1.25] text-balance text-neutral-900 md:leading-[1.3]"
      >
        {formatShortlistPageTitle({ jobTitle, location })}
      </Heading>

      <p className="text-neutral-650 mt-3 text-sm text-pretty md:text-base">
        For{' '}
        <span className="font-semibold text-neutral-900">{companyName}</span>
        {' · '}
        {formatShortlistPageMetaSuffix({ count })}
      </p>
    </motion.header>
  );
}
